import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authSlice } from "./api/authSlice";
import { userReducer } from "./reducer/UserReducer";
import { userSlice } from "./api/userSlice";
import { configurationSlice } from "./api/configurationSlice";
import { vehiclesSlice } from "./api/vendor/vehiclesSlice";
import { driversSlice } from "./api/vendor/driversSlice";
import { VendorSlice } from "./api/school/VendorSlice";
import { ReservationSlice } from "./api/school/ReservationSlice";
import { PraentSlice } from "./api/school/PraentSlice";
import { routesSchedulesSlice } from "./api/vendor/routesSchedulesSlice";
import { maintainanceSlice } from "./api/vendor/MaintainanceSlice";
import { seatAvailabilitySlice } from "./api/vendor/seatAvailabilitySlice";
import { regulatoryComplianceSlice } from "./api/vendor/regulatoryComplianceSlice";
import { notificationsSlice } from "./api/admin/notificationsSlice";
import { MessagesSlice } from "./api/vendor/MessagesSlice";
import { ratingSlice } from "./api/vendor/ratingSlice";
import { paymentSlice } from "./api/admin/paymentSlice";
import { paymentHistorySlice } from "./api/school/PaymentHistorySlice";
import { dashboardSlice } from "./api/admin/dashboardSlice";
import { dashboardSchoolSlice } from "./api/school/dashboardSchoolSlice";
import { vendorDashboardSlice } from "./api/vendor/vendorDashboardSlice";
import { myBookingSlice } from "./api/admin/bookingSlice";
import { ReportingAnalyticsSlice } from "./api/school/ReportingSlice";
import { registrationSlice } from "./api/parent/registrationSlice";
import { GetReservationsSlice } from "./api/parent/GetReservationSlice";
import { dashboardParentSlice } from "./api/parent/dashboardParentSlice";
import { trackingSlice } from "./api/trackingSlice";
import { bankSlice } from "./api/admin/bankSlice";
import { reservationDetailSlice } from "./api/reservationDetailSlice";
import { manualPaymentSlice } from "./api/manualPaymentSlice";
import { externalChargeSlice } from "./api/externalChargeSlice";
import { aiSlice } from "./api/aiSlice";

const persistConfig = {
  key: "user",
  storage,
  whitelist: ["user", "tempData"],
};

// Redux Persist config for user slice
const persistedUserReducer = persistReducer(persistConfig, userReducer.reducer);

// Export combined reducer object
export const rootReducer = {
  reducer: {
    [userReducer.name]: persistedUserReducer,
    [authSlice.reducerPath]: authSlice.reducer,
    [userSlice.reducerPath]: userSlice.reducer,
    [vehiclesSlice.reducerPath]: vehiclesSlice.reducer,
    [driversSlice.reducerPath]: driversSlice.reducer,
    [configurationSlice.reducerPath]: configurationSlice.reducer,
    [VendorSlice.reducerPath]: VendorSlice.reducer,
    [ReservationSlice.reducerPath]: ReservationSlice.reducer,
    [PraentSlice.reducerPath]: PraentSlice.reducer,
    [routesSchedulesSlice.reducerPath]: routesSchedulesSlice.reducer,
    [maintainanceSlice.reducerPath]: maintainanceSlice.reducer,
    [seatAvailabilitySlice.reducerPath]: seatAvailabilitySlice.reducer,
    [regulatoryComplianceSlice.reducerPath]: regulatoryComplianceSlice.reducer,
    [notificationsSlice.reducerPath]: notificationsSlice.reducer,
    [MessagesSlice.reducerPath]: MessagesSlice.reducer,
    [ratingSlice.reducerPath]: ratingSlice.reducer,
    [paymentSlice.reducerPath]: paymentSlice.reducer,
    [paymentHistorySlice.reducerPath]: paymentHistorySlice.reducer,
    [dashboardSlice.reducerPath]: dashboardSlice.reducer,
    [dashboardSchoolSlice.reducerPath]: dashboardSchoolSlice.reducer,
    [vendorDashboardSlice.reducerPath]: vendorDashboardSlice.reducer,
    [myBookingSlice.reducerPath]: myBookingSlice.reducer,
    [ReportingAnalyticsSlice.reducerPath]: ReportingAnalyticsSlice.reducer,

    // parent
    [registrationSlice.reducerPath]: registrationSlice.reducer,
    [GetReservationsSlice.reducerPath]: GetReservationsSlice.reducer,
    [dashboardParentSlice.reducerPath]: dashboardParentSlice.reducer,

    // tracking
    [trackingSlice.reducerPath]: trackingSlice.reducer,

    // bank
    [bankSlice.reducerPath]: bankSlice.reducer,

    // reservation detail (shared across all roles)
    [reservationDetailSlice.reducerPath]: reservationDetailSlice.reducer,

    // manual payment (school, vendor, admin)
    [manualPaymentSlice.reducerPath]: manualPaymentSlice.reducer,

    // external charge / receive payment (school, vendor, admin)
    [externalChargeSlice.reducerPath]: externalChargeSlice.reducer,

    // AI chatbot
    [aiSlice.reducerPath]: aiSlice.reducer,
  },
  devTools: process.env.REACT_APP_NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(
      authSlice.middleware,
      userSlice.middleware,
      vehiclesSlice.middleware,
      driversSlice.middleware,
      configurationSlice.middleware,
      VendorSlice.middleware,
      ReservationSlice.middleware,
      PraentSlice.middleware,
      routesSchedulesSlice.middleware,
      maintainanceSlice.middleware,
      seatAvailabilitySlice.middleware,
      regulatoryComplianceSlice.middleware,
      notificationsSlice.middleware,
      MessagesSlice.middleware,
      ratingSlice.middleware,
      paymentSlice.middleware,
      paymentHistorySlice.middleware,
      dashboardSlice.middleware,
      dashboardSchoolSlice.middleware,
      vendorDashboardSlice.middleware,
      myBookingSlice.middleware,
      ReportingAnalyticsSlice.middleware,
      registrationSlice.middleware,
      GetReservationsSlice.middleware,
      dashboardParentSlice.middleware,
      trackingSlice.middleware,
      bankSlice.middleware,
      reservationDetailSlice.middleware,
      manualPaymentSlice.middleware,
      externalChargeSlice.middleware,
      aiSlice.middleware,
    ),
};
